import {
    GetValidatedWeekResponse,
    GetValidatedWeeksResponse,
} from "../../types/api/validatedWeek";
import { Mindset } from "../../types/enums/Mindset";
import { request } from "../apiService";

export const validateWeek = async (
    weekNumber: number,
    year: number,
    mindset: Mindset,
    file: File,
    comment?: string | null
) => {
    const formData = new FormData();

    formData.append("file", file);
    formData.append("mindset", mindset);
    formData.append("weeknumber", weekNumber.toString());
    formData.append("year", year.toString());
    if (comment != null && comment.trim() !== "") {
        formData.append("comment", comment.trim());
    }

    return await request<void>("/v3/tradingsessions/validatedweeks", {
        method: "POST",
        headers: {
            "Content-Type": "multipart/form-data",
        },
        input: formData,
    });
};

export const getValidatedWeeksByUserId = async (userId: string) => {
    return await request<GetValidatedWeeksResponse>(
        `/v3/tradingsessions/validatedweeks?userId=${userId}`
    );
};

export const getValidatedWeekByUserIdAndWeek = async (
    userId: string,
    weekNumber: number,
    year: number
) => {
    return await request<GetValidatedWeekResponse>(
        `/v3/tradingsessions/validatedweeks/${year}/${weekNumber}?userId=${userId}`
    );
};

export const deleteValidatedWeek = async (
    year: number,
    weekNumber: number,
    userId: string
) => {
    return await request<void>(
        `/v3/tradingsessions/validatedweeks/${year}/${weekNumber}?userId=${userId}`,
        { method: "DELETE" }
    );
};
